import { render, staticRenderFns } from "./FiltroCaracterizacaoCard.vue?vue&type=template&id=4f5c84d0&scoped=true&lang=pug"
import script from "./FiltroCaracterizacaoCard.vue?vue&type=script&lang=js"
export * from "./FiltroCaracterizacaoCard.vue?vue&type=script&lang=js"
import style0 from "./FiltroCaracterizacaoCard.vue?vue&type=style&index=0&id=4f5c84d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5c84d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VIcon})
